import { render } from "./ForgetPwd.vue?vue&type=template&id=698de2ea&scoped=true"
import script from "./ForgetPwd.vue?vue&type=script&lang=js"
export * from "./ForgetPwd.vue?vue&type=script&lang=js"

import "./ForgetPwd.vue?vue&type=style&index=0&id=698de2ea&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698de2ea"]])

export default __exports__